module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-item"
  }, [_c('ProductDetailsComponent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.product.align == 'left'),
      expression: "product.align == 'left'"
    }],
    staticClass: "force-mobile",
    attrs: {
      "product": _vm.product
    }
  }), _vm._v(" "), _c('ProductImageComponent', {
    attrs: {
      "product": _vm.product
    }
  }), _vm._v(" "), _c('ProductDetailsComponent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.product.align == 'right'),
      expression: "product.align == 'right'"
    }],
    staticClass: "hide-mobile",
    attrs: {
      "product": _vm.product
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87d9fbea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/AttachProductComponents/SingleProductComponent.vue
// module id = 494
// module chunks = 0